<template>
  <div class="md-layout" :key="isOpenForm">
    <div class="md-layout-item md-size-100" v-show="!isOpenForm">
      <md-card>
        <md-card-header class="dark-header">
          <h4 class="title">
            Danh sách nhân viên
            <!-- <md-button @click="updateAll">update all</md-button> -->
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <md-button class="md-info md-dense" @click="showDialog = true"
              >Chính sách CTV</md-button
            >
            <md-button
              class="md-success md-dense"
              @click="addUser"
              style="margin-left: 10px"
              >Thêm nhân viên</md-button
            >
          </div>
          <br />
          <div class="md-layout md-size-100">
            <div class="md-layout-item md-size-20">
              <md-field>
                <label>Vai trò</label>
                <md-select v-model="filter.permission">
                  <md-option :value="-1">Tất cả</md-option>
                  <md-option value="Nhân viên bán hàng"
                    >Nhân viên bán hàng</md-option
                  >
                  <md-option value="Cộng tác viên">Cộng tác viên</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20">
              <md-field>
                <label>Trạng thái</label>
                <md-select v-model="filter.isBanned">
                  <md-option :value="-1">Tất cả</md-option>
                  <md-option :value="false">Đang hoạt động</md-option>
                  <md-option :value="true">Bị khóa</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <div class="scroll-x">
            <table id="customer">
              <tr>
                <th>STT</th>
                <th>Mã nhân viên</th>
                <th>Tên nhân viên</th>
                <th>Email</th>
                <th>Địa chỉ</th>
                <th>Số điện thoại</th>
                <th>Vai trò</th>
                <th>Số dư tài khoản</th>
                <th>Khóa</th>
                <th>Xóa</th>
              </tr>
              <tr
                :key="index"
                v-for="(item, index) in queriedData"
                class="clickable"
                v-bind:class="{
                  saler: item.data.permission === 'Cộng tác viên',
                  danger: item.data.isBanned,
                }"
                @click="editUser(item, listUser.indexOf(item))"
              >
                <td>
                  {{ listUser.indexOf(item) + 1 }}
                </td>
                <td>
                  {{ item.data.employeeCode }}
                </td>
                <td>
                  {{ item.data.name }}
                </td>
                <td>
                  {{ item.data.email }}
                </td>
                <td>
                  {{
                    item.data.address.length > 20
                      ? item.data.address.substring(0, 20) + "..."
                      : item.data.address
                  }}
                  <md-tooltip v-show="item.data.address.length > 20">{{
                    item.data.address
                  }}</md-tooltip>
                </td>
                <td>
                  {{ item.data.phone }}
                </td>
                <td>
                  {{ item.data.permission }}
                </td>
                <td>
                  {{
                    item.data.deposit &&
                    item.data.permission === "Cộng tác viên"
                      ? formatMoney(item.data.deposit)
                      : ""
                  }}
                </td>
                <td @click.stop="confirmBanUser(item)">
                  <div v-show="!item.data.isBanned" style="color: green">
                    <i class="fas fa-lock-open"></i>
                    <md-tooltip>Tài khoản đang hoạt động</md-tooltip>
                  </div>
                  <div v-show="item.data.isBanned" style="color: red">
                    <i class="fas fa-lock"></i>
                    <md-tooltip>Tài khoản bị khóa</md-tooltip>
                  </div>
                </td>
                <td @click.stop="confirmDeleteUser(item)" class="clickable">
                  <div style="color: red">
                    <i class="fas fa-user-times"></i>
                    <md-tooltip>Xóa tài khoản</md-tooltip>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">Hiển thị từ {{ from + 1 }} đến {{ to }}</p>
          </div>
          <span v-show="queriedData.length < pagination.perPage"
            ><i>Đã tải hết dữ liệu ({{ listUser.length }} nhân viên)</i></span
          >
          <div class="pagination clickable">
            <!-- <div
              style="margin-right: 10px;"
              @click="previusPage"
              v-show="pagination.currentPage !== 1"
              class="md-alignment-center-center md-layout"
            >
              <md-button class="md-simple md-sm">
                <i class="fas fa-angle-double-left"></i>
                Trang trước
              </md-button>
            </div>
            <div
              @click="nextPage"
              v-show="queriedData.length === pagination.perPage"
              class="md-alignment-center-center md-layout"
            >
              <md-button class="md-simple md-sm">
                Trang sau
                <i class="fas fa-angle-double-right"></i>
              </md-button>
            </div> -->
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </pagination>
          </div>
        </md-card-actions>
      </md-card>
    </div>
    <User
      v-if="isOpenForm"
      :isAddUser="isAddUser"
      :userSelected="userSelected"
      @close="close"
    >
    </User>
    <dialog-user-policy
      :db="db"
      :showDialog="showDialog"
      @closeDialog="showDialog = false"
    />
  </div>
</template>
<script>
import { ProductCard, Pagination } from "@/components";
import firebase from "@/services/firebase-init.js";
import Swal from "sweetalert2";
export default {
  components: {
    User: () => import("./User.vue"),
    dialogUserPolicy: () => import("./dialogUserPolicy.vue"),
    Pagination,
  },
  created() {
    this.db = firebase.firestore();
    this.functions = firebase.functions();
    this.getData(this.pagination.perPage * 2);
  },
  data() {
    return {
      showDialog: false,
      index: null,
      filter: {
        isBanned: -1,
        permission: -1,
      },
      functions: null,
      db: {},
      pagination: {
        perPage: 100,
        currentPage: 1,
        total: 0,
      },
      userSelected: {},
      listUser: [],
      defaultAvatar: "./img/default-avatar.png",
      addAvater: "./img/addIcon.png",
      isAddUser: false,
      isOpenForm: false,
    };
  },
  methods: {
    // updateAll() {
    //   this.listUser.forEach(user => {
    //     this.$set(user.data, "listProductId", []);
    //     this.$set(user.data, "listProducts", []);
    //     this.db
    //       .collection(process.env.VUE_APP_USER)
    //       .doc(user.id)
    //       .update(user.data)
    //       .then(() => {
    //         console.log("success")
    //       })
    //       .catch(error => console.log(error));
    //   });
    // },
    getData(limit) {
      let bits = localStorage.getItem("bits");
      let query = this.db.collection(process.env.VUE_APP_USER + bits);
      if (this.filter.permission !== -1) {
        query = query.where("permission", "==", this.filter.permission);
      }
      if (this.filter.isBanned !== -1) {
        query = query.where("isBanned", "==", this.filter.isBanned);
      }
      this.$store.dispatch("FLAG_LOADING", true);
      query
        .where(
          "employeeCode",
          ">",
          this.listUser[this.listUser.length - 1]
            ? this.listUser[this.listUser.length - 1].data.employeeCode
            : ""
        )
        .limit(limit ? limit : this.pagination.perPage)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((item) => {
            this.listUser.push({
              id: item.id,
              data: item.data(),
            });
          });
          this.$store.dispatch("FLAG_LOADING", false);
        });
    },
    previusPage() {
      if (this.pagination.currentPage !== 1) {
        this.pagination.currentPage--;
      }
    },
    async nextPage() {
      if (
        this.queriedData[this.queriedData.length - 1] ===
          this.listUser[this.listUser.length - this.pagination.perPage - 1] &&
        this.queriedData.length === this.pagination.perPage
      ) {
        this.pagination.currentPage++;
        await this.getData(null);
      } else if (
        this.queriedData[this.queriedData.length - 1] !==
        this.listUser[this.listUser.length - 1]
      )
        this.pagination.currentPage++;
      else alert("Đã hết dữ liệu");
    },
    addUser() {
      this.userSelected = {};
      this.isAddUser = true;
      this.isOpenForm = true;
    },
    editUser(item, index) {
      this.isAddUser = false;
      this.isOpenForm = true;
      this.index = index;
      this.userSelected = item;
    },
    confirmBanUser(item) {
      Swal.fire({
        title: !item.data.isBanned
          ? "Khóa tài khoản: " + item.data.employeeCode
          : "Mở khóa tài khoản: " + item.data.employeeCode,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("FLAG_LOADING", true);
          !item.data.isBanned ? this.banUser(item) : this.enableUser(item);
        }
      });
    },
    banUser(item) {
      let banThisUser = this.functions.httpsCallable(
        process.env.VUE_APP_DISABLE_USER_FUNC
      );
      banThisUser({
        email: item.data.email,
      })
        .then((result) => {
          if (result.success === false) {
            this.$messageError("Có lỗi, Thử lại!");
            this.$store.dispatch("FLAG_LOADING", false);
          } else {
            this.updateBandUser(item);
            this.$messageSuccess("Đã khóa tài khoản");
          }
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
          this.$messageError("Có lỗi, Thử lại!");
        });
    },
    enableUser(item) {
      let enableThisUser = this.functions.httpsCallable(
        process.env.VUE_APP_ENABLE_USER_FUNC
      );
      enableThisUser({
        email: item.data.email,
      })
        .then((result) => {
          if (result.success === false) {
            this.$store.dispatch("FLAG_LOADING", false);
            this.$messageError("Có lỗi, Thử lại!");
          } else {
            this.updateEnableUser(item);
            this.$messageSuccess("Đã mở khóa tài khoản");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$messageError("Có lỗi, Thử lại!");
        });
    },
    updateBandUser(item) {
      item.data.isBanned = true;
      this.updateUser(item);
    },
    updateEnableUser(item) {
      item.data.isBanned = false;
      this.updateUser(item);
    },
    updateUser(item) {
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_USER + bits)
        .doc(item.id)
        .update(item.data)
        .then(() => {
          this.$store.dispatch("FLAG_LOADING", false);
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
        });
    },
    pushItem(docRef) {
      (this.listUser = []),
        this.listUser.push({
          id: docRef.id,
          data: docRef.data(),
        });
    },
    close(e) {
      let bits = localStorage.getItem("bits");
      this.userSelected = {};
      this.isAddUser = false;
      this.isOpenForm = false;
      if (e) {
        this.$store.dispatch("FLAG_LOADING", true);
        this.db
          .collection(process.env.VUE_APP_USER + bits)
          .where("employeeCode", "==", e)
          .get()
          .then((docRef) => {
            docRef.forEach((item) => {
              this.index !== null
                ? (this.listUser[this.index].data = Object.assign(
                    {},
                    item.data()
                  ))
                : this.pushItem(item);
              this.index = null;
              this.$store.dispatch("FLAG_LOADING", false);
            });
          })
          .catch((error) => {
            this.$store.dispatch("FLAG_LOADING", false);
            this.index = null;
            console.log(error);
          });
      }
    },
    confirmDeleteUser(item) {
      Swal.fire({
        title: "Xóa tài khoản: " + item.data.name,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let bits = localStorage.getItem("bits");
          this.$store.dispatch("FLAG_LOADING", true);
          let deleteFunc = this.functions.httpsCallable(
            process.env.VUE_APP_DELETE_USER_FUNC + bits
          );
          deleteFunc({
            email: item.data.email,
          })
            .then((result) => {
              this.$store.dispatch("FLAG_LOADING", false);
              if (result.success === false) {
                this.$messageError("Có lỗi, Thử lại!");
              } else {
                this.listUser = [];
                this.getData(this.pagination.perPage * 2);
                this.$messageSuccess("Đã xóa tài khoản");
              }
            })
            .catch((error) => {
              console.log(error);
              this.$messageError("Có lỗi, Thử lại!");
            });
        }
      });
    },
  },
  computed: {
    filterState() {
      return this.filter.permission + this.filter.isBanned.toString();
    },
    queriedData() {
      let result = this.listUser;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.listUser.length;
    },
  },
  watch: {
    filterState() {
      this.listUser = [];
      this.pagination.currentPage = 1;
      this.getData(this.pagination.perPage * 2);
    },
    "pagination.currentPage"() {
      if (this.pagination.currentPage >= this.total / this.pagination.perPage) {
        this.getData(this.pagination.perPage);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.add-user {
  font-size: 15px !important;
  background-color: rgba(0, 128, 0, 0.39) !important;
  padding: 3px 0 3px 0 !important;
}
.button-add {
  margin: 15px;
  float: right;
}

.table-border {
  border: solid rgba(0, 0, 0, 0.178) 1px;
  border-radius: 10px;
}
.pagination {
  color: rgba(0, 0, 0, 0.301);
  font-size: 13px;
}
#customer {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius: 10px;
  overflow-x: scroll;
}

#customer td,
#customer th {
  padding: 8px 10px 8px 10px;
  border: 1px solid #ddd;
  max-width: 20vw;
}

#customer tr:hover {
  background-color: #ddd;
}

#customer th {
  text-align: left;
  background-color: rgba(0, 165, 14, 0.356);
  color: rgb(0, 0, 0);
  font-style: normal;
  font-weight: normal;
}
.nummeric {
  text-align: right !important;
}
.saler {
  background-color: rgba(51, 104, 101, 0.171);
}
.danger {
  background: rgba(222, 184, 135, 0.397);
}
</style>
